import React from 'react';
import { Modal, Input, Form, Radio, Table, Tabs, Button, Divider, Empty, Switch } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { Search } = Input;
const { TabPane } = Tabs;

class FormModalSustento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkValueSustento: 1
        }
    }

    onChange = (e) => {
        this.setState({
            checkValueSustento: e.target.value,
        });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }
    handleDetalle = () => {
        this.props.onAgregarDetalle(this.state.checkValueSustento)
    }
    handleDocumento = () => {
        this.props.onBuscarDocumentos(this.state.checkValueSustento)
    }
    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            debugger
            if (!err) {
                const form = {
                    id: 0,
                    idCajaChicaSolicitud: values.idCajaChicaSolicitud,
                    fechaSustento: this.props.formValues.fechaReferencial,
                    numero: values.numero,
                    montoSolicitud: parseFloat(values.montoSolicitud),
                    montoSustento: parseFloat(values.montoSustento),
                    montoCaja: parseFloat(values.montoDisponible),
                    montoDevuelto: parseFloat(values.montoDevuelto),
                    montoPendiente: parseFloat(values.montoPendiente),
                    flagSobrante: (parseFloat(values.montoSustento) < parseFloat(values.montoSolicitud)) ? true : false,
                    flagFaltante: (parseFloat(values.montoSustento) > parseFloat(values.montoSolicitud)) ? true : false,
                    idTipoSustento: this.state.checkValueSustento,
                    listaCajaChicaSustentarDetalle: this.props.formValues.listaComprobanteDetalle
                }

                const validFormLogic = this.validateFormLogic(form, values);
                if (!validFormLogic) {
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    validateFormLogic = (data, values) => {

        if (data.listaCajaChicaSustentarDetalle.length == 0) {
            dialog.warning("Debe tener al menos 1 referencia de sustento.");
            return false;
        }
        var montoDevolver = Math.abs(data.montoSolicitud - data.montoSustento);


        if (data.montoDevuelto > parseFloat(montoDevolver)) {
            dialog.warning("El monto de devolucion tiene que ser menor o igual al monto sobrante.");
            return false;
        }

        if (data.montoCaja < parseFloat(data.montoDevuelto)) {
            dialog.warning("No se puede hacer la devolucion ya que en la caja el saldo es " + parseFloat(this.props.formValues.montoDisponible).toFixed(2));
            return false;
        }
        return true;
    };



    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('idCajaChicaSolicitud', { initialValue: this.props.formValues.idCajaChicaSolicitud });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Sustento de Monto Solicitado" + this.props.formValues.nroCajaChica : "Modificar Sustento de Monto Solicitado " + this.props.formValues.nroCajaChica}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={(properties) => {
                    if (!properties.target.className.toString().match("ant-modal-wrap") || properties.type === "keydown")
                        this.handleCancel();
                }}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="700px"
            >
                <Form>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label={"Serie - Correlativo"}>
                                {getFieldDecorator("correlativo", {
                                    initialValue: this.props.formValues.serie + '-' + this.props.formValues.correlativo,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Correlativo",
                                        },
                                    ],
                                })(
                                    <Input
                                        readOnly
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label={"Nro Solicitud"}>
                                {getFieldDecorator("numero", {
                                    initialValue: this.props.formValues.numero,
                                    rules: [
                                        {
                                            required: true,
                                            message: "numero",
                                        },
                                    ],
                                })(
                                    <Input
                                        readOnly
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">


                        <div className="col-md-6">
                            <Form.Item label={"Monto Disponible en Caja " + (this.props.formValues.moneda)}
                                hasFeedback
                                validateStatus={this.props.formValues.montoDisponible > 0 ? "success" : "error"}>
                                {getFieldDecorator(`montoDisponible`, {
                                    initialValue: parseFloat(this.props.formValues.montoDisponible).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }]
                                })(
                                    <Input
                                        placeholder="Monto Pen"
                                        autoComplete="off"
                                        readOnly
                                        id="success"
                                        onKeyPress={global.onKeyPressDecimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label={"Monto Solicitado " + (this.props.formValues.moneda)}
                                hasFeedback
                                validateStatus={this.props.formValues.montoSolicitud > 0 ? "success" : "error"}
                            >

                                <Form.Item>
                                    {getFieldDecorator(`montoSolicitud`, {
                                        initialValue: parseFloat(this.props.formValues.montoSolicitud).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Monto Pen"
                                            autoComplete="off"
                                            readOnly
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                this.props.form.setFieldsValue({
                                                    montoSolicitud: global.onBlurDecimals(e, 2)
                                                });
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Form.Item>
                        </div>


                        <div className="col-md-6">
                            <Form.Item label={"Monto Sustentado " + (this.props.formValues.moneda)}
                            >
                                {getFieldDecorator(`montoSustento`, {
                                    initialValue: parseFloat(this.props.formValues.montoSustento).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }]
                                })(
                                    <Input
                                        placeholder="Monto Sustento"
                                        autoComplete="off"
                                        readOnly
                                        id="success"
                                        onKeyPress={global.onKeyPressDecimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label={"Sobrante / Faltante " + (this.props.formValues.moneda)}
                                hasFeedback
                                validateStatus={this.props.formValues.montoPendiente > 0 ? "success" : "error"}
                            >

                                <Form.Item>
                                    {getFieldDecorator(`montoPendiente`, {
                                        initialValue: parseFloat(Math.abs(this.props.formValues.montoPendiente)).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Monto Pendiente"
                                            autoComplete="off"
                                            readOnly
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                this.props.form.setFieldsValue({
                                                    montoPendiente: global.onBlurDecimals(e, 2)
                                                });
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Form.Item>
                        </div>

                        <div className="col-md-6" hidden>
                            <Form.Item label="Sobrante / Faltante devolver totalidad">
                                {getFieldDecorator('flagTotal', {
                                    initialValue: this.props.formValues.flagTotal,
                                    valuePropName: 'checked'
                                })(
                                    <Switch checkedChildren="Parcial" unCheckedChildren="Total" disabled
                                    //onChange={(e) => this.props.onChangeForm("flagTotal", e, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label={"Monto Devuelto " + (this.props.formValues.moneda)}>

                                <Form.Item>
                                    {getFieldDecorator(`montoDevuelto`, {
                                        initialValue: parseFloat(this.props.formValues.montoDevuelto).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Monto Pen"
                                            autoComplete="off"
                                            disabled={
                                                (parseFloat(this.props.formValues.montoSustento) > parseFloat(this.props.formValues.montoSolicitud)) ? false : true}
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                this.props.form.setFieldsValue({
                                                    montoDevuelto: global.onBlurDecimals(e, 2)
                                                });
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Form.Item>
                        </div>
                        <div className="col-md-12">
                            <Form.Item label="Seleccione el tipo de sustento">
                                <Radio.Group defaultValue={this.state.checkValueSustento} buttonStyle="solid" onChange={this.onChange}>
                                    <Radio.Button value={1}>Registrar Compra</Radio.Button>
                                    <Radio.Button value={2}>Registrar Movilidad</Radio.Button>
                                    <Radio.Button value={3}>Otros documentos no tributarios</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                            <Divider
                            />
                        </div>

                

                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="file"
                                            type="primary"
                                            onClick={this.handleDocumento}

                                        >
                                            Recuperar Documentos
                                        </Button>

                                        <Button
                                            icon="plus"
                                            type="success"
                                            onClick={this.handleDetalle}
                                        >
                                            Siguiente
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Documentos" key="1">

                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.identifier}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='No se han agregado productos'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Tipo Sustento',
                                                dataIndex: 'tipoSustento',
                                                key: 'tipoSustento',
                                                align: 'center',
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Documento Sustento',
                                                dataIndex: 'serieCorrelativo',
                                                key: 'serieCorrelativo',
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Moneda Original',
                                                dataIndex: 'moneda',
                                                key: 'moneda',
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Monto Sustentado',
                                                dataIndex: 'montoSustento',
                                                key: 'montoSustento',
                                                align: 'center',
                                                width: 90,
                                                render: (value) => (
                                                    <span>{value.toFixed(2)}</span>
                                                )
                                            }
                                        ]}
                                    />
                                </TabPane>

                            </Tabs>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModalSustento)